import axios from 'axios';
import Cookies from 'universal-cookie';

const COOKIES = new Cookies();
export const TOKEN = COOKIES.get('tokenKYCSafecash');

export const URL_SERVER = process.env.REACT_APP_URL_SERVER;
export const API_VERIFY = URL_SERVER + '/api/kyc/users';

const CONFIG = {
  headers: {
    'X-Access-Token': TOKEN
  }
};

const backToLogin = () => {
  COOKIES.remove('tokenKYCSafecash', { path: '/'})
  COOKIES.remove('usernameKYCSafecash', { path: '/'})
  window.location.href = '/'
}

axios.interceptors.response.use( (response) =>  response,
  err => {
    if (err.response && err.response.status === 401) {
      backToLogin();
    }
    return Promise.reject(err);
  }
)

export function API_GET_DATA_QUEUE (idUser) {
  const QUEUE = idUser ? idUser : 'queue';
  const API_QUEUE = API_VERIFY + '/' + QUEUE;
  return axios.get(API_QUEUE, CONFIG)
}

export function API_REJECT_GROUP (user, data) {
  const API_REJECT = API_VERIFY + '/' + user.userId + '/groups/' + user.groupCode + '/reject';
  return axios.patch(API_REJECT, data, CONFIG);
}

export function API_APPROVE_GROUP (user) {
  const API_APPROVE = API_VERIFY + '/' + user.userId + '/groups/' + user.groupCode + '/verify';
  return axios.patch(API_APPROVE, {}, CONFIG);
}

export function API_RELEASE_USER (user) {
  const API_RELEASE = API_VERIFY + '/' + user.userId + '/release';
  return axios.patch(API_RELEASE, {}, CONFIG);
}

export function API_QUERY_USER (param) {
  const API_QUERY = API_VERIFY + '/search?searchQuery=' + param.query + '&page=' + param.page;
  return axios.get(API_QUERY, CONFIG);
}

export function API_QUERY_USER_BY_NIK (param) {
  const API_QUERY = API_VERIFY + '/search?searchQuery=' + param.query + '&searchField=ktp_nik&page=' + param.page;
  return axios.get(API_QUERY, CONFIG);
}

export function API_USER_LOGIN (param) {
  const API_LOGIN = URL_SERVER + '/api/auth/token';
  const Action =  axios.post(API_LOGIN, param);

  if(!Action){
    COOKIES.remove('tokenVerify', { path: '/'})
    COOKIES.remove('username', { path: '/'})
    window.location.href = '/'
  }
  return Action;
}

export function API_GET_CS_DAILY () {
  const DASHBOARD_CS_DAILY = URL_SERVER + '/api/kyc/statistics/customer-service/daily';
  return axios.get(DASHBOARD_CS_DAILY, CONFIG);
}

export function API_GET_USER_DAILY (date) {
  const DASHBOARD_USER_DAILY = URL_SERVER + '/api/kyc/statistics/users/daily?from=' + date.dateFrom + '&to=' + date.dateTo;
  return axios.get(DASHBOARD_USER_DAILY, CONFIG);
}

export function API_SEARCH_NIK (NIK, userId) {
  const SEARCH_NIK = URL_SERVER + '/api/kyc/fields/ktp_nik/search-duplicate?fieldValue=' + NIK + '&currentUserId=' + userId;
  return axios.get(SEARCH_NIK, CONFIG);
}

export function API_GET_ENTRY () {
  const GET_ENTRY = API_VERIFY + '/data-entry-queue';
  return axios.get(GET_ENTRY, CONFIG);
}

export function API_UPDATE_ENTRY ({userId, groupCode, fieldCode, fieldValue}) {
  const UPDATE_ENTRY = `${URL_SERVER}/api/kyc/users/${userId}/groups/${groupCode}/fields/${fieldCode}/update`;
  return axios.patch(UPDATE_ENTRY, {fieldValue}, CONFIG);
}

export function API_RELEASE_ENTRY (userId) {
  const RELEASE_ENTRY = API_VERIFY + '/' + userId + '/data-entry-release';
  return axios.patch(RELEASE_ENTRY, {}, CONFIG);
}

export function API_STATISTIC_ENTRY () {
  const STATISTIC_ENTRY = URL_SERVER + '/api/kyc/statistics/customer-service/data-entry/total';
  return axios.get(STATISTIC_ENTRY, CONFIG);
}

export function API_DAILY_ENTRY () {
  const STATISTIC_ENTRY = URL_SERVER + '/api/kyc/statistics/customer-service/data-entry/daily';
  return axios.get(STATISTIC_ENTRY, CONFIG);
}

export function API_REQUEST_AKSES (data) {
  const REQUEST_PATCH = `${URL_SERVER}/api/kyc/users/${data.userId}/request-access-documents`;
  return axios.patch(REQUEST_PATCH, {}, CONFIG);
}

export function API_CODE_AREA (codeId) {
  const SEARCH_AREA_CODE = `${URL_SERVER}/api/kyc/area/${codeId}`;
  return axios.get(SEARCH_AREA_CODE, CONFIG);
}


// WEBPACK FOOTER //
// ./src/app/api/index.js